/* import axios from 'axios' */
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/contratos/relatorios`

export default {
    obterFiltrosOpcoes(tipo) {
        return axiosJwt
            .get(`${api}/filtrosopcoes/${tipo}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    emitirRelatorio(relatorio, filtros) {
        let filtrosString = '?'

        if (filtros.contrato) {
            filtrosString = `${filtrosString}contrato=${filtros.contrato.replace(
                '/',
                '-'
            )}&`
        }

        if (filtros.responsavel) {
            filtrosString = `${filtrosString}responsavel=${filtros.responsavel}&`
        }

        if (filtros.unidade) {
            filtrosString = `${filtrosString}unidade=${filtros.unidade}&`
        }

        if (filtros.fornecedor) {
            filtrosString = `${filtrosString}fornecedor=${filtros.fornecedor}&`
        }

        if (filtros.processo) {
            filtrosString = `${filtrosString}processo=${filtros.processo}&`
        }

        if (filtros.documento) {
            filtrosString = `${filtrosString}documento=${filtros.documento}&`
        }

        if (filtros.comprometimento) {
            filtrosString = `${filtrosString}comprometimento=${filtros.comprometimento}&`
        }

        if (filtros.statusComprometimento != null) {
            filtrosString = `${filtrosString}statusComprometimento=${filtros.statusComprometimento}&`
        }

        if (filtros.dataMovimentoDe) {
            filtrosString = `${filtrosString}dataMovimentoDe=${filtros.dataMovimentoDe}&`
        }

        if (filtros.dataMovimentoAte) {
            filtrosString = `${filtrosString}dataMovimentoAte=${filtros.dataMovimentoAte}`
        }

        if (filtros.dataInicioDe) {
            filtrosString = `${filtrosString}dataInicioDe=${filtros.dataInicioDe}&`
        }

        if (filtros.dataInicioAte) {
            filtrosString = `${filtrosString}dataInicioAte=${filtros.dataInicioAte}&`
        }

        if (filtros.dataFimDe) {
            filtrosString = `${filtrosString}dataFimDe=${filtros.dataFimDe}&`
        }

        if (filtros.dataFimAte) {
            filtrosString = `${filtrosString}dataFimAte=${filtros.dataFimAte}&`
        }

        if (filtros.apenasAtivos) {
            filtrosString = `${filtrosString}apenasAtivos=${filtros.apenasAtivos}&`
        }

        if (filtros.dataRequisicaoDe) {
            filtrosString = `${filtrosString}dataRequisicaoDe=${filtros.dataRequisicaoDe}&`
        }

        if (filtros.dataRequisicaoAte) {
            filtrosString = `${filtrosString}dataRequisicaoAte=${filtros.dataRequisicaoAte}&`
        }

        return axiosJwt
            .get(`${api}/${relatorio}${filtrosString}`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
